import React from 'react';
import {TripBoardsModalApolloProvider} from '@homeaway/react-trip-board-button';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';

export default function TripBoardsProviderContainer({
    siteName,
    isLoggedIn,
    adultsCount,
    childrenCount,
    endDate,
    petIncluded,
    startDate
}) {
    const tripBoardProviderParams = {
        adultsCount,
        childrenCount,
        endDate,
        petIncluded,
        startDate
    };

    return (
        <>
            <ErrorBoundary label="TripBoardsModalReduxProvider">
                <TripBoardsModalApolloProvider
                    siteName={siteName}
                    {...tripBoardProviderParams}
                    isLoggedIn={isLoggedIn}
                    autosave
                    showCoachmark
                />
            </ErrorBoundary>
        </>
    );
}
